/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Tab_ScrapedInputs */

const en_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraped Jobs`)
};

const de_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gescrapte Stellen`)
};

const fr_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplois récupérés`)
};

const es_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleos recopilados`)
};

const it_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavori trovati`)
};

const nl_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevonden banen`)
};

const pl_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znalezione oferty`)
};

const fi_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haetut työpaikat`)
};

const da_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrabede job`)
};

const sv_jobs_tab_scraped = /** @type {(inputs: Jobs_Tab_ScrapedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrapade jobb`)
};

/**
* | output |
* | --- |
* | "Scraped Jobs" |
*
* @param {Jobs_Tab_ScrapedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_tab_scraped = /** @type {((inputs?: Jobs_Tab_ScrapedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Tab_ScrapedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_tab_scraped(inputs)
	if (locale === "fr") return fr_jobs_tab_scraped(inputs)
	if (locale === "es") return es_jobs_tab_scraped(inputs)
	if (locale === "it") return it_jobs_tab_scraped(inputs)
	if (locale === "nl") return nl_jobs_tab_scraped(inputs)
	if (locale === "pl") return pl_jobs_tab_scraped(inputs)
	if (locale === "fi") return fi_jobs_tab_scraped(inputs)
	if (locale === "da") return da_jobs_tab_scraped(inputs)
	if (locale === "sv") return sv_jobs_tab_scraped(inputs)
	return en_jobs_tab_scraped(inputs)
});